import React from 'react'
import { Stack } from '@mui/material'
import Header from './Header'
import Details from './Details'
import Footer from './Footer'
import { CanteenCartItem } from '../types'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenCartUserDataFragment = graphql(`
  fragment CanteenCart_UserDataFragment on User {
    ...CanteenCartHeader_UserDataFragment
    ...CanteenCartDetails_UserDataFragment
    ...CanteenCartFooter_UserDataFragment
  }
`)

type Props = {
  cartItems: CanteenCartItem[]
  currency: string
  cartTotal: number
  onClose: () => void
  onUpdate: (updatedItem: CanteenCartItem) => void
  onRemove: (itemReference: string) => void
  onChangeTimeslot: (timeslot: string) => void
  onCheckoutClicked: () => void
  loading: boolean
  orderSucceeded: boolean
  onDismissError: () => void
  arrivalTime: string
  availableSubsidy: number
  timeslots: { id: string; startTime: string; endTime: string }[]
  error: string | null
  userData: FragmentType<typeof canteenCartUserDataFragment>
}

const Cart: React.FC<Props> = (props) => {
  const {
    cartItems,
    cartTotal,
    onClose,
    onDismissError,
    loading,
    error,
    onChangeTimeslot,
    arrivalTime,
    orderSucceeded,
    onCheckoutClicked,
    onUpdate,
    onRemove,
    availableSubsidy,
    timeslots,
    userData: userDataProp,
    currency,
  } = props
  const userData = useFragment(canteenCartUserDataFragment, userDataProp)

  const handleUpdate = (cartItem: CanteenCartItem) => {
    onUpdate(cartItem)
  }

  return (
    <Stack width="100%" height="100vh" direction="column">
      <Header
        availableSubsidy={availableSubsidy}
        timeslots={timeslots}
        userData={userData}
        onClose={onClose}
        onChangeTimeslot={onChangeTimeslot}
        arrivalTime={arrivalTime}
      />
      <Details
        cartTotal={cartTotal}
        onRemove={onRemove}
        availableSubsidy={availableSubsidy}
        userData={userData}
        cartItems={cartItems}
        onUpdate={handleUpdate}
        onDismissError={onDismissError}
        error={error}
      />
      <Footer
        currency={currency}
        cartTotal={cartTotal}
        availableSubsidy={availableSubsidy}
        userData={userData}
        cartItems={cartItems}
        onClose={onClose}
        onCheckoutClicked={() => onCheckoutClicked()}
        loading={loading}
        orderSucceeded={orderSucceeded}
      />
    </Stack>
  )
}

export default Cart
